import { ssv2307UsuroCadtrCrtorResource } from '@/shared/api.resource';

import {
  FETCH_SSV2307_USURO_CADTR_CRTOR_BY_ID,
  FETCH_PAGINATED_SSV2307_USURO_CADTR_CRTORS,
  UPDATE_SSV2307_USURO_CADTR_CRTOR,
  CREATE_SSV2307_USURO_CADTR_CRTOR,
  DELETE_SSV2307_USURO_CADTR_CRTOR,
  RESET_SSV2307_USURO_CADTR_CRTOR_FILTERS,
  RESET_SSV2307_USURO_CADTR_CRTOR,
  RESET_SSV2307_USURO_CADTR_CRTORS_LIST,
} from './actions.type';

import {
  SET_SSV2307_USURO_CADTR_CRTOR,
  SET_PAGINATED_SSV2307_USURO_CADTR_CRTORS,
  RESET_STATE_SSV2307_USURO_CADTR_CRTOR_FILTERS,
  RESET_STATE_SSV2307_USURO_CADTR_CRTOR,
  RESET_STATE_SSV2307_USURO_CADTR_CRTOR_LIST,
} from './mutations.type';

const initialState = {
  ssv2307UsuroCadtrCrtorFilters: {},
  ssv2307UsuroCadtrCrtor: {},
  paginatedSsv2307UsuroCadtrCrtors: {
    content: [],
    totalElements: 0,
    size: 0
  }
};

export const state = JSON.parse(JSON.stringify(initialState));

export const actions = {
  async [FETCH_SSV2307_USURO_CADTR_CRTOR_BY_ID](context, id) {
    const { data } = await ssv2307UsuroCadtrCrtorResource.get({ id: id });
    context.commit(SET_SSV2307_USURO_CADTR_CRTOR, data);
    return data;
  },
  async [FETCH_PAGINATED_SSV2307_USURO_CADTR_CRTORS](context, params) {
    const { data } = await ssv2307UsuroCadtrCrtorResource.query(params);
    context.commit(SET_PAGINATED_SSV2307_USURO_CADTR_CRTORS, data);
    return data;
  },
  async [CREATE_SSV2307_USURO_CADTR_CRTOR](context) {
    const { data } = await ssv2307UsuroCadtrCrtorResource.save(state.ssv2307UsuroCadtrCrtor);
    context.commit(SET_SSV2307_USURO_CADTR_CRTOR, data);
    return data;
  },
  async [UPDATE_SSV2307_USURO_CADTR_CRTOR](context, id) {
    const { data } = await ssv2307UsuroCadtrCrtorResource.update({ id: id }, state.ssv2307UsuroCadtrCrtor);
    context.commit(SET_SSV2307_USURO_CADTR_CRTOR, data);
    return data;
  },
  [DELETE_SSV2307_USURO_CADTR_CRTOR](context, id) {
    return ssv2307UsuroCadtrCrtorResource.delete({ id: id });
  },
  [RESET_SSV2307_USURO_CADTR_CRTOR_FILTERS]({ commit }) {
    commit(RESET_STATE_SSV2307_USURO_CADTR_CRTOR_FILTERS);
  },
  [RESET_SSV2307_USURO_CADTR_CRTOR]({ commit }) {
    commit(RESET_STATE_SSV2307_USURO_CADTR_CRTOR);
  },
  [RESET_SSV2307_USURO_CADTR_CRTORS_LIST]({ commit }) {
    commit(RESET_STATE_SSV2307_USURO_CADTR_CRTOR_LIST);
  }
};

export const mutations = {
  [SET_SSV2307_USURO_CADTR_CRTOR](state, ssv2307UsuroCadtrCrtor) {
    state.ssv2307UsuroCadtrCrtor = ssv2307UsuroCadtrCrtor;
  },
  [SET_PAGINATED_SSV2307_USURO_CADTR_CRTORS](state, paginatedSsv2307UsuroCadtrCrtors) {
    state.paginatedSsv2307UsuroCadtrCrtors = paginatedSsv2307UsuroCadtrCrtors;
  },
  [RESET_STATE_SSV2307_USURO_CADTR_CRTOR](state) {
    state.ssv2307UsuroCadtrCrtor = JSON.parse(JSON.stringify(initialState.ssv2307UsuroCadtrCrtor));
  },
  [RESET_STATE_SSV2307_USURO_CADTR_CRTOR_FILTERS](state) {
    state.ssv2307UsuroCadtrCrtorFilters = JSON.parse(JSON.stringify(initialState.ssv2307UsuroCadtrCrtorFilters));
  },
  [RESET_STATE_SSV2307_USURO_CADTR_CRTOR_LIST](state) {
    state.paginatedssv2307UsuroCadtrCrtors = JSON.parse(JSON.stringify(initialState.paginatedSsv2307UsuroCadtrCrtors));
  }
};

export const getters = {
  ssv2307UsuroCadtrCrtor(state) {
    return state.ssv2307UsuroCadtrCrtor;
  },
  ssv2307UsuroCadtrCrtorFilters(state) {
    return state.ssv2307UsuroCadtrCrtorFilters;
  },
  paginatedSsv2307UsuroCadtrCrtors(state) {
    return state.paginatedSsv2307UsuroCadtrCrtors;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}